import React, { FC, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, Card, IconTextButton, NavMenu, Typography } from '@scope/scope-one-ui/core';
import { rsrTabs } from '../../modules/common/RestrictedSubscriptionRatings/const';
import { UsersList } from '../../modules/common/RestrictedSubscriptionRatings/UsersList';
import { RatingsList } from '../../modules/common/RestrictedSubscriptionRatings/RatingsList';
import AddUserIcon from '../../assets/icons/user-plus.svg';
import {
  AddUserVariant,
  AddUserVariants,
  SubscriptionRatingType,
} from '../../modules/common/RestrictedSubscriptionRatings/types';
import { getSubscriptionRatingsLabel } from '../../shared/constants/subscriptionRatings';

export const RestrictedSubscriptionRatings: FC = () => {
  const navigate = useNavigate();
  const { tabSelected, ratingType = 'rsr' } = useParams<{
    tabSelected: rsrTabs;
    ratingType: SubscriptionRatingType;
  }>();
  const [isAddUserModalOpen, setIsAddUserModalOpen] = useState(false);
  const [addUserVariant, setAddUserVariant] = useState<AddUserVariant>(AddUserVariants.INVITE);

  const views = [
    { label: 'Ratings', path: `/admin-panel/${ratingType}/ratings` },
    { label: 'Users', path: `/admin-panel/${ratingType}/users` },
  ];

  const tabs = views.map(({ label, path }) => ({ label, onClick: () => navigate(path) }));

  const active =
    tabs.map((tab) => tab.label).find((label) => label.toLowerCase() === tabSelected) ||
    tabs[0].label;

  useEffect(() => {
    if (tabSelected) return;

    navigate(views[0].path);
  }, [tabSelected, ratingType]);

  return (
    <>
      <Box my={2}>
        <Card padded>
          <Box display="flex" justifyContent="space-between" gridGap={1}>
            <Typography variant="h1">{getSubscriptionRatingsLabel(ratingType)}</Typography>
            {tabSelected === rsrTabs.USERS && (
              <Box display="flex" gridGap={1}>
                <IconTextButton
                  icon={<AddUserIcon width={32} height={32} />}
                  iconSize="regular"
                  onClick={() => {
                    setAddUserVariant(AddUserVariants.INVITE);
                    setIsAddUserModalOpen(true);
                  }}
                >
                  INVITE USER
                </IconTextButton>
              </Box>
            )}
          </Box>
        </Card>
      </Box>
      <NavMenu active={active} tabs={tabs} />
      <Box mt={2}>
        {tabSelected === rsrTabs.RATINGS && <RatingsList ratingType={ratingType} />}
        {tabSelected === rsrTabs.USERS && (
          <UsersList
            ratingType={ratingType}
            isAddUserModalOpen={isAddUserModalOpen}
            setIsAddUserModalOpen={setIsAddUserModalOpen}
            addUserVariant={addUserVariant}
            setAddUserVariant={setAddUserVariant}
          />
        )}
      </Box>
    </>
  );
};
